import {
  SHOW_CUSTOMER_DETAILS,
  SHOW_LEFT_SIDE_IN_CONTACT_PAGE,
  SHOW_RIGHT_SIDE_IN_CHAT,
  SHOW_SEARCH_BAR,
  SHOW_MESSAGE_INFO_BAR,
  SHOW_CREATE_NEW_GROUP_BAR,
  SHOW_SUGGESTED_GROUPS_BAR,
  SHOW_MEDIA_BAR,
  SHOW_STARRED_MESSAGES_BAR,
  SHOW_PHOTO_MODAL,
} from "./constants";

const initialState = {
  showCustomerDetails: false,
  showLeftSideInContactPage: true,
  showRightSideInChat: true,
  showSearchBar: false,
  showMessageInfoBar: false,
  showCreateNewGroupBar: false,
  showSuggestedGroupsBar: false,
  showMediaBar: false,
  showStarredMessagesBar: false,
  showPhotoModal: false,
  photoURL: "",
  contentType: "",
};

const styleReducer = (state = initialState, { value, type, body, contentType }) => {
  switch (type) {
    case SHOW_CUSTOMER_DETAILS:
      return { ...state, showCustomerDetails: value };
    case SHOW_LEFT_SIDE_IN_CONTACT_PAGE:
      return { ...state, showLeftSideInContactPage: value };
    case SHOW_RIGHT_SIDE_IN_CHAT:
      return { ...state, showRightSideInChat: value };
    case SHOW_SEARCH_BAR:
      return { ...state, showSearchBar: value };
    case SHOW_MESSAGE_INFO_BAR:
      return { ...state, showMessageInfoBar: value };
    case SHOW_CREATE_NEW_GROUP_BAR:
      return { ...state, showCreateNewGroupBar: value };
    case SHOW_SUGGESTED_GROUPS_BAR:
      return { ...state, showSuggestedGroupsBar: value };
    case SHOW_MEDIA_BAR:
      return { ...state, showMediaBar: value };
    case SHOW_STARRED_MESSAGES_BAR:
      return { ...state, showStarredMessagesBar: value };
    case SHOW_PHOTO_MODAL:
      return { ...state, showPhotoModal: value, photoURL: body, modalContentType: contentType };
    default:
      return state;
  }
};

export default styleReducer;
